<template>
	<div>
		<Tabs :tab="tab" @checkTab="checkTab"></Tabs>
		
		<router-view :type="type" :is="tab" :formData="formData" @stopQuery="$emit('stopQuery')" @checkTab="checkTab"></router-view>
	</div>
</template>

<script>
	const Tabs = () => import('./Tabs');
	const Personal = () => import('./Personal');
	const Questions = () => import('./Questions');
	const Bodily = () => import('./Bodily');
	const Biochemical = () => import('./Biochemical');
	const Newborn = () => import('./Newborn');
	const Puerpera = () => import('./Puerpera');
	
	export default{
		name: 'dataTemplate',
		data() {
			return {
				tab: 'Personal' ,//默认从个人信息开始填写
				
			}
		},
		components: {
			Tabs,
			Personal,
			Questions,
			Bodily,
			Biochemical,
			Newborn,
			Puerpera
		},
		props: [ 'type', 'formData' ],
		methods: {
			//切换tab 参数 tab组件名
			checkTab(tab) {
				this.tab = tab;
			}
		}
	}
</script>

<style>
</style>
